// extracted by mini-css-extract-plugin
export default {"cls1":"TruncateHeight-cls1__a3ef8d4f04ca8375d957","cls2":"TruncateHeight-cls2___fa8e98574a63c55d0d9 TruncateHeight-cls1__a3ef8d4f04ca8375d957"};